import React from "react";
import { useTranslation } from "react-i18next";

// common
import {
  ModalText,
  ModalLayout,
  LargeModalStyling,
  MoreModalButtons,
} from "common/modal";

// modals
const { LargeModal } = LargeModalStyling;
const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ButtonContainer } = MoreModalButtons;

type GroupModalProps = {
  visible: boolean;
  onCloseModal: () => void;
};

const NoBookedGroupModal = ({ visible, onCloseModal }: GroupModalProps) => {
  const { t } = useTranslation("book_a_class");

  return (
    <LargeModal
      title={t("MY GROUP CLASS")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t(
          "This class is less than 48 hours from now and no student signed up for it. We cancelled it to avoid teaching a class without students. " +
            "If a class has no other students in it, please sign up at least 48 hours in advance so we know there will be at least one student joining."
        )}
      </ConfirmationText>
      <ModalRow gutter={24}>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonYellow
            type="primary"
            onClick={() => {
              onCloseModal();
            }}
          >
            {t("OKAY")}
          </ModalButtonYellow>
        </ButtonContainer>
      </ModalRow>
    </LargeModal>
  );
};

export default NoBookedGroupModal;
